import styled from "styled-components";

export const Root = styled.div<{ isModalOpen: boolean; mainColor: string }>`
  position: relative;
  float: left;
  margin-right: 5px;
  font-size: 15px;
  z-index: 1001;

  .head {
    line-height: 35px;
    font-weight: 600;
    color: ${(props) => props.mainColor};
    user-select: none;
    cursor: pointer;
  }
`;

export const SettingsDropdownBody = styled.div`
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 16px;

  .footer {
    display: flex;
    justify-content: center;
    margin-top: 3px;
  }
`;
